import { useCallback, useRef } from 'react';

// Guards async fetchers against out-of-order responses. Call begin() at the
// start of each fetch; it returns isCurrent(), which stays true only until the
// next begin(). Check it after every await before setting state, so a slow
// response to an older request (the user picked another store, window or
// brand in the meantime) can't overwrite the newer request's data — and only
// the newest request clears the loading state.
export function useLatestRequest() {
  const seq = useRef(0);
  return useCallback(() => {
    const id = ++seq.current;
    return () => id === seq.current;
  }, []);
}
